import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../imageService';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { ScreensContext } from '../contexts/screensContext';
import HomeScreen from '../components/sms-prl/home-screen';
import useScreenHistory from '../hooks/useScreenHistory';

const SmsPRL = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 0
  });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('sms-prl');
    sendEvent('age_verification_without');
    sessionStorage.setItem('unsubscription_source', 'Parliament_Limited');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 0: {
        return (
          <HomeScreen
            setScreenNumber={cb}
            backgroundImage={`url("${getImageFromS3(
              'images/sms-prl/bg.png'
            )}")`}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default SmsPRL;
